<ng-container *transloco="let t; read: 'inventory'">
  <ng-container *transloco="let tGlobal; read: 'global'">
    @if (vm$ | async; as vm) {
      <div class="componentContainer">
        <section class="xs12col componentHeader">
          <h1>{{t('title')}}</h1>
        </section>
        <section class="oneCol">
          <div class="xs12col">
            <div class="boxContainer">
              <div class="box">
                <h2 class="padding-bottom-medium">{{t('searchTitle')}}</h2>
                <form
                  [formGroup]="filterForm"
                  (ngSubmit)="onSubmit(vm.searchRequest)"
                  class="searchForm">
                  @if (isAdminView) {
                    <kendo-formfield>
                      <kendo-label [text]="t('columns.company')"></kendo-label>
                      <kendo-dropdownlist
                        [data]="vm.companies"
                        textField="name"
                        valueField="id"
                        [defaultItem]="{ id: null, name: t('chooseCustomer') }"
                        [kendoDropDownFilter]="filterSettings"
                        formControlName="companyId"
                        [valuePrimitive]="true">
                      </kendo-dropdownlist>
                    </kendo-formfield>
                  }
                  <kendo-formfield>
                    <kendo-label [text]="t('columns.active')"></kendo-label>
                    <kendo-dropdownlist
                      [data]="activeOptions"
                      textField="name"
                      valueField="id"
                      [defaultItem]="{ id: null, name: t('chooseActive') }"
                      formControlName="active"
                      [valuePrimitive]="true">
                    </kendo-dropdownlist>
                  </kendo-formfield>
                  <kendo-formfield>
                    <kendo-label [text]="t('columns.nextService')"></kendo-label>
                    <kendo-dropdownlist
                      [data]="nextServiceOptions"
                      textField="name"
                      valueField="id"
                      [defaultItem]="{ id: null, name: t('nextServiceAll') }"
                      formControlName="nextServiceFilter"
                      [valuePrimitive]="true">
                    </kendo-dropdownlist>
                  </kendo-formfield>
                  @if (filterForm.value.nextServiceFilter === nextServiceFilters.Range) {
                    <kendo-daterange class="xs12col m6col k-form-field">
                      <kendo-label [text]="t('nextServiceRangeLabel')" class="label"></kendo-label>
                      <kendo-dateinput
                        kendoDateRangeStartInput
                        formControlName="nextServiceFrom"
                        [placeholder]="t('placeholderFrom')"
                      ></kendo-dateinput>
                      <kendo-dateinput
                        kendoDateRangeEndInput
                        formControlName="nextServiceTo"
                        [placeholder]="t('placeholderTo')"
                      ></kendo-dateinput>
                    </kendo-daterange>
                  }
                  <kendo-formfield>
                    <div class="searchInputContainer">
                      <span class="tooltipContainer">
                        <kendo-label [text]="t('filterSearch')"></kendo-label>
                        <span [attr.tooltip]="t('tooltipSearch')" flow="right" class="tooltipContainer">
                          <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                        </span>
                      </span>
                      <kendo-textbox
                        formControlName="keyword" class="searchTextField">
                      </kendo-textbox>
                    </div>
                  </kendo-formfield>
                  <div class="buttonContainer padding-bottom-large">
                    <button
                      [disabled]="filterForm.invalid || filterForm.pristine"
                      type="submit"
                      kendoButton
                      class="buttonPrimary">
                      {{t('filterSearch')}}
                    </button>
                    <button
                      type="button"
                      (click)="resetFilter()"
                      class="buttonSecondary">
                      {{ t('resetFilter') }}
                    </button>
                  </div>
                </form>
                <kendo-grid
                  [data]="vm.inventoryDevices"
                  [skip]="vm.gridState.skip"
                  [pageSize]="vm.gridState.pageSize"
                  [pageable]="true"
                  [sortable]="{ allowUnsort: true }"
                  [sort]="sort"
                  (sortChange)="sortChange($event, vm.searchRequest)"
                  [rowClass]="rowClass"
                  [loading]="loading"
                  (pageChange)="pageChangeSub$.next($event)">
                  @if ('Permissions.InventoryDevices.Create' | permission) {
                    <ng-template kendoGridToolbarTemplate>
                      <a kendoGridAddCommand [routerLink]="['new']" [attr.tooltip]="t('add')" class="addIcon">
                        <span class="icon">
                          <img src="../../../assets/icons/add-icon.svg">
                        </span>
                        <span>{{t('add')}}</span>
                      </a>
                    </ng-template>
                  }
                  @if (isAdminView) {
                    <kendo-grid-column field="company.name" [title]="t('columns.company')" media="(min-width: 993px)">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.company?.name || '-'}}
                      </ng-template>
                    </kendo-grid-column>
                  }
                  <kendo-grid-column field="serialNumber" [title]="t('columns.serialNumber')" media="(min-width: 993px)">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{dataItem.serialNumber || '-'}}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="name" [title]="t('columns.name')" media="(min-width: 993px)">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{dataItem.name || '-'}}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="manufacturer" [title]="t('columns.manufacturer')" media="(min-width: 993px)">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{dataItem.manufacturer || '-'}}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="location" [title]="t('columns.location')" media="(min-width: 993px)">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{dataItem.location || '-'}}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="active" [title]="t('columns.active')" media="(min-width: 993px)">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{ dataItem.active ? t('activeYes') : t('activeNo') }}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="nextService" [title]="t('columns.nextService')" media="(min-width: 993px)">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <span>{{ formatDate(dataItem.nextService) }}</span>
                    </ng-template>
                  </kendo-grid-column>
                  <!-- MOBILE GRID -->
                  <kendo-grid-column-group media="(max-width: 992px)">
                    @if (isAdminView) {
                      <kendo-grid-column>
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <h4 class="mobileGridHeader">{{t('columns.company')}}</h4>
                          <span>{{dataItem.company?.name || '-'}}</span>
                        </ng-template>
                      </kendo-grid-column>
                    }
                    <kendo-grid-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">{{t('columns.serialNumber')}}</h4>
                        <span>{{dataItem.serialNumber || '-'}}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">{{t('columns.name')}}</h4>
                        <span>{{dataItem.name || '-'}}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">{{t('columns.location')}}</h4>
                        <span>{{dataItem.location || '-'}}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column>
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <h4 class="mobileGridHeader">{{t('columns.nextService')}}</h4>
                        <span>{{ formatDate(dataItem.nextService) }}</span>
                      </ng-template>
                    </kendo-grid-column>
                  </kendo-grid-column-group>
                  <kendo-grid-command-column>
                    <ng-template
                      kendoGridCellTemplate
                      let-dataItem>
                      <a
                        [routerLink]="[dataItem.id]"
                        [attr.tooltip]="t('open')"
                        flow="up"
                        class="actionIcon">
                        <img src="../../../assets/icons/open-link-icon.svg">
                      </a>
                    </ng-template>
                  </kendo-grid-command-column>
                  <!-- Paging -->
                  <ng-template
                    let-totalPages="totalPages"
                    let-currentPage="currentPage"
                    kendoPagerTemplate>
                    <div class="flex gridPagination">
                      <div class="flex flexDirRow gridRow">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-numeric-buttons
                          [buttonCount]="5"
                        ></kendo-pager-numeric-buttons>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                      </div>
                      <div class="gridRow">
                        <kendo-buttongroup [selection]="'single'" id="pageBtnGroup">
                          <button
                            (click)="pageChangeSub$.next({
                              skip: vm.gridState.skip,
                              take: pageSizes.Small
                            })"
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Small"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Small }}
                          </button>
                          <button
                            (click)="pageChangeSub$.next({
                              skip: vm.gridState.skip,
                              take: pageSizes.Medium
                            })"
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Medium"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Medium }}
                          </button>
                          <button
                            (click)="pageChangeSub$.next({
                              skip: vm.gridState.skip,
                              take: pageSizes.Large
                            })"
                            kendoButton
                            [selected]="vm.gridState.pageSize === pageSizes.Large"
                            [toggleable]="true"
                            >
                            {{ pageSizes.Large }}
                          </button>
                        </kendo-buttongroup>
                        <button
                          kendoButton
                          [title]="t('refresh')"
                          class="reloadIcon"
                          (click)="searchRequest$.next(vm.searchRequest)">
                          <img class="actionIcon" src="../assets/icons/reload.svg">
                        </button>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template kendoGridNoRecordsTemplate>
                    <div class="text pl">{{t('noResults')}}</div>
                  </ng-template>
                  <ng-template kendoGridLoadingTemplate>
                    <div class="k-loading-color"></div>
                    <div class="loading-container">
                      <kendo-loader type="converging-spinner" size="large"></kendo-loader>
                    </div>
                  </ng-template>
                </kendo-grid>
              </div>
            </div>
          </div>
        </section>
      </div>
    }
  </ng-container>
</ng-container>